import type { BaseQueryFn, QueryActionCreatorResult, QueryDefinition } from '@reduxjs/toolkit/query'
import type { BaseCheckResponse } from '#api/tmsApiService'
import type { CheckResult, CheckResultUpdate } from '#types/ConfigurationCheck'
import { getCheckErrorCount } from '#utils/checkHelpers'

export type ResultUpdater = (result: CheckResultUpdate) => void

export async function runCheck<R extends BaseCheckResponse, C extends QueryDefinition<unknown, BaseQueryFn, string, R>>(
  query: QueryActionCreatorResult<C>,
  initialData: Omit<CheckResult, 'status' | 'startTime'>,
  updater: ResultUpdater,
) {
  updater({
    ...initialData,
    status: 'progress',
    startTime: Date.now(),
  })

  try {
    const { data, error, isError, isSuccess } = await query

    if (isError || error) {
      updater({
        id: initialData.id,
        status: 'failure',
        endTime: Date.now(),
        error: error,
      })
    } else if (isSuccess) {
      const hasResultErrors =
        getCheckErrorCount({
          id: initialData.id,
          status: 'success',
          startTime: Date.now(),
          endTime: Date.now(),
          data: data,
        }) > 0

      updater({
        id: initialData.id,
        status: hasResultErrors ? 'failure' : 'success',
        endTime: Date.now(),
        data: data,
      })
    }
  } catch (_error) {
    updater({
      id: initialData.id,
      status: 'failure',
      endTime: Date.now(),
      error: 'Failed',
    })
  }
}
